import { IBaseAction, PaginationQuery } from '../../constants';
import { Moment } from 'moment-jalaali'

export interface Letter {
    number: string;
    airline: string;
    subject: string;
    replyTo: string;
    date: Moment;
    flights: Array<any>;
}

export interface PreviewRequestReportInitialState { }
export const PREVIEW_REQUEST_REPORT = 'PREVIEW_REQUEST_REPORT';
export const PREVIEW_REQUEST_REPORT_SUCCESS = 'PREVIEW_REQUEST_REPORT_SUCCESS';
export const PREVIEW_REQUEST_REPORT_FAILURE = 'PREVIEW_REQUEST_REPORT_FAILURE';
export const PREVIEW_REQUEST_REPORT_CLEAR = 'PREVIEW_REQUEST_REPORT_CLEAR';

export interface PreviewRequestReportAction extends IBaseAction {
    type:
    | typeof PREVIEW_REQUEST_REPORT
    | typeof PREVIEW_REQUEST_REPORT_SUCCESS
    | typeof PREVIEW_REQUEST_REPORT_FAILURE
    | typeof PREVIEW_REQUEST_REPORT_CLEAR;
    payload?: {
        data: PreviewRequestReportInitialState;
    };
}

export interface CreateRequestReportInitialState { }
export const CREATE_REQUEST_REPORT = 'CREATE_REQUEST_REPORT';
export const CREATE_REQUEST_REPORT_SUCCESS = 'CREATE_REQUEST_REPORT_SUCCESS';
export const CREATE_REQUEST_REPORT_FAILURE = 'CREATE_REQUEST_REPORT_FAILURE';
export const CREATE_REQUEST_REPORT_CLEAR = 'CREATE_REQUEST_REPORT_CLEAR';

export interface CreateRequestReportAction extends IBaseAction {
    type:
    | typeof CREATE_REQUEST_REPORT
    | typeof CREATE_REQUEST_REPORT_SUCCESS
    | typeof CREATE_REQUEST_REPORT_FAILURE
    | typeof CREATE_REQUEST_REPORT_CLEAR;
    payload?: {
        data: CreateRequestReportInitialState;
    };
}

export interface FlightRequestReport {
    airline: string;
    type: string;
    name: string;
    creatorId: string;
    createdAt: Date;
}

export interface FlightRequestReportsListState {
    data: FlightRequestReport[];
    total: 0;
}

export interface FlightRequestReportsListInitialState {
    flightRequestReports: Array<FlightRequestReport>;
}
export const FLIGHT_REQUEST_REPORT_LIST = 'FLIGHT_REQUEST_REPORT_LIST';
export const FLIGHT_REQUEST_REPORT_LIST_SUCCESS = 'FLIGHT_REQUEST_REPORT_LIST_SUCCESS';
export const FLIGHT_REQUEST_REPORT_LIST_FAILURE = 'FLIGHT_REQUEST_REPORT_LIST_FAILURE';
interface GetFlightRequestReportsList extends IBaseAction {
    type: typeof FLIGHT_REQUEST_REPORT_LIST | typeof FLIGHT_REQUEST_REPORT_LIST_SUCCESS | typeof FLIGHT_REQUEST_REPORT_LIST_FAILURE;
    payload: {
        data: FlightRequestReportsListInitialState;
    };
}

export class GetFlightRequestReportsListQuery extends PaginationQuery {
    constructor() {
        super();
    }
}

export type FlightRequestReportActionTypes = CreateRequestReportAction
    | PreviewRequestReportAction
    | GetFlightRequestReportsList;    